import { useState, useRef } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import api, { apiErr, fileUrl } from "@/lib/api";
import { Upload, Loader2, X } from "lucide-react";

export default function ImageUpload({ value, onChange, testid = "image-upload", label = "Görsel" }) {
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef();

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Görsel yüklendi");
    } catch (err) {
      toast.error(apiErr(err.response?.data?.detail));
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-3">
        {value ? (
          <div className="relative">
            <img src={fileUrl(value)} alt="" className="w-14 h-14 rounded-lg object-cover border border-slate-200" />
            <button type="button" onClick={() => onChange("")} className="absolute -top-2 -right-2 w-5 h-5 bg-slate-700 text-white rounded-full flex items-center justify-center">
              <X className="w-3 h-3" />
            </button>
          </div>
        ) : (
          <div className="w-14 h-14 rounded-lg border border-dashed border-slate-300 flex items-center justify-center text-slate-300">
            <Upload className="w-5 h-5" />
          </div>
        )}
        <Button type="button" variant="outline" size="sm" disabled={uploading} onClick={() => inputRef.current?.click()} data-testid={`${testid}-button`}>
          {uploading ? <Loader2 className="w-4 h-4 animate-spin" /> : `${label} Yükle`}
        </Button>
        <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={handleFile} data-testid={`${testid}-input`} />
      </div>
      <Input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="veya görsel URL yapıştırın" className="h-9 text-sm" />
    </div>
  );
}
